exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.searchable-demo-file-list {\n  height: 100%;\n  background-color: white;\n  overflow: auto;\n}\n.searchable-demo-file-list__node--pre-selected {\n    background-color: #1fc8db;\n}\n", ""]);

// exports
